import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { DatePipe } from '@angular/common';
import { SistemaService } from '@services/sistema/sistema.service';
import { EstadoSistema } from 'src/app/common/interfaces/estadosistema.interface';
import { ToolsService } from '@services/varios/tools.service';

@Component({
  selector: 'app-sistema',
  templateUrl: './sistema.component.html',
  styleUrls: ['./sistema.component.scss'],
  providers: [DatePipe] // Proveedor de DatePipe
})
export class SistemaComponent implements OnInit {

  constructor(private readonly spinnerService: SpinnerService,
              private readonly toolsService: ToolsService,
              private readonly sistema : SistemaService,
  ) { }
  
  public estadoSistema: boolean = true;
  public mensajeSistema: string = '';

  async ngOnInit(): Promise<void> {
    let estSis = await this.sistema.getEstadoSistemaByIdSistema();
    this.estadoSistema = estSis.estadoSistema === 'ACTIVO';
    this.mensajeSistema = estSis.mensajeSistema;
  }

  async guardarEstadoSistema() {
    let spinnerRef = this.spinnerService.start();

    let estadoSistemaNuevo: EstadoSistema = {} as EstadoSistema;
    estadoSistemaNuevo.estadoSistema = this.estadoSistema ? 'ACTIVO' : 'INACTIVO';
    estadoSistemaNuevo.mensajeSistema = this.mensajeSistema;

    let resp = await this.sistema.updateEstadoSistema(estadoSistemaNuevo);

    this.spinnerService.stop(spinnerRef);

    if (resp === 'ok') {
      await this.toolsService.okMensaje('Operación realizada con éxito');
    } else {
      await this.toolsService.errorMensaje('Error al guardar.');
    }

  }
}